import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Packages
import Slider from 'react-slick'
import shortid from 'shortid'

// Components
import YouTubePlayer from '../../Global/YouTubePlayer'
import HudlVideoPlayer from '../../Global/HudlVideoPlayer'
import SliderArrow from './SliderArrow'

// Utils
import { isImage } from '../../../utils/helpers'

class ProfileSlider extends Component {
  static propTypes = {
    slides: PropTypes.array.isRequired,
  }

  beforeSlideChange = (currentSlide) => {
    Object.keys(this.refs).forEach((key, index) => {
      if (currentSlide === index) {
        const ref = this.refs[key]
        ref.pauseVideoPlayback()
      }
    })
  }

  renderVideoSlide(slideSource, index) {
    let videoPlayer = this.getVideoPlayer(slideSource, index)
    return videoPlayer
    ? (
      <div key={shortid.generate()}>
        <div className="slider-content-container">
          <div
            className="slider-content"
          >
            {videoPlayer}
          </div>
        </div>
      </div>
    ) : null
  }

  getVideoPlayer(slideSource, index) {
    let videoId = getVideoId(slideSource)

    if (isYouTube(slideSource)) {
      return (
        <YouTubePlayer
          videoId={videoId}
          ref={'youtubePlayer' + index}
        />
      )
    } else if (isHudl(slideSource)) {
      return (
        <HudlVideoPlayer
          ref={'hudlPlayer' + index}
          videoId={videoId}
          title={`Hudl Athlete Video #${index}`}
        />
      )
    }
  }

  render() {
    let { slides } = this.props

    let settings = {
      arrows: slides.length > 1 ? true : false,
      dots: false,
      draggable: slides.length > 1 ? true : false,
      infinite: false,
      nextArrow: <SliderArrow type='next' />,
      prevArrow: <SliderArrow type='prev' />,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500,
    }

    return (
      <div className={`profile-slider${slides.length === 1 ? ' single-slide' : ''}`}>
        <div className="profile-slider-inner">
          <Slider
            {...settings}
            beforeChange={this.beforeSlideChange}
          >
            {
              slides.map((slideSource, index) => {
                return isImage(slideSource)
                ? (
                    <div key={shortid.generate()}>
                      <div className="slider-content-container">
                        <div
                          className="slider-content"
                          style={ {backgroundImage: `url(${slideSource})`} }
                        />
                      </div>
                    </div>
                  )
                : this.renderVideoSlide(slideSource, index)
              })
            }
          </Slider>
        </div>
      </div>
    )
  }
}

const isYouTube = (value) => {
  return value.includes('youtu') ? true : false
}

const isHudl = (value) => {
  return value.includes('hudl') ? true : false
}

const getVideoId = (value) => {
  let videoId = ''

  if (value.includes('youtu')) {
    if (value.includes('watch?v=')) {
      // If URL is straight from video viewing...
      return value.split('watch?v=')[1]
    } else if (value.includes('youtu.be/')) {
      // If URL is from the 'Share' modal
      return value.split('youtu.be/')[1]
    }
  } else if (value.includes('hudl')) {
    if (value.includes('hudl.com/embed/video/')) {
      videoId = value.split('hudl.com/embed/video/')[1]
      return videoId.substring(0, videoId.indexOf("'"))
    } else if (value.includes('hudl.com/video/')) {
      return value.split('hudl.com/video/')[1]
    }
  }
}

export default ProfileSlider



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileSlider/ProfileSlider.js